import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import { Card } from "antd";
import Title from "antd/es/typography/Title";
import { ProjectsByTypeRealisation } from "../../domaine/dashboardModel";

interface ProjectsByTypeRealisationChartProps {
  data: ProjectsByTypeRealisation;
}

const ProjectsByTypeRealisationChart: React.FC<
  ProjectsByTypeRealisationChartProps
> = ({ data }) => {
  const chartRef = useRef<HTMLDivElement>(null);
  const chartInstance = useRef<echarts.ECharts | null>(null);

  useEffect(() => {
    // Initialize chart
    if (chartRef.current) {
      chartInstance.current = echarts.init(chartRef.current);
    }

    // Clean up function
    return () => {
      chartInstance.current?.dispose();
    };
  }, []);

  useEffect(() => {
    if (!chartInstance.current || !data) return;
  
    const chartData = [
      { value: data["En totalité"] ? data["En totalité"].count : 0, name: "En totalité" },
      { value: data["Par tranches"] ? data["Par tranches"].count : 0, name: "Par tranches" },
    ];
  
    const option = {
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b}: {c} ({d}%)",
      },
      legend: {
        orient: "horizontal",
        bottom: "bottom",
        data: ["En totalité", "Par tranches"],
      },
      series: [
        {
          name: "Type de réalisation",
          type: "pie",
          radius: ["50%", "70%"],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: "#fff",
            borderWidth: 2,
          },
          label: {
            show: false,
            position: "center",
          },
          emphasis: {
            label: {
              show: true,
              fontSize: "18",
              fontWeight: "bold",
            },
          },
          labelLine: {
            show: false,
          },
          data: chartData,
          color: ["#1890ff", "#52c41a"],
        },
      ],
    };
  
    chartInstance.current.setOption(option);
  
    // Define the resize handler separately
    const handleResize = () => {
      chartInstance.current?.resize();
    };
  
    window.addEventListener("resize", handleResize);
  
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [data]);
  

  return (
    <Card style={{ border: "2px solid #42005a" }}>
      <Title level={5} style={{ width: "100%", textAlign: "center" }}>
        Projets par type de réalisation
      </Title>
      <div ref={chartRef} style={{ height: "170px", width: "100%" }}></div>
    </Card>
  );
};

export default ProjectsByTypeRealisationChart;
